import { BasePageProvider } from 'components/base-page-provider/base-page-provider.component';
import { FullPageLoadingSpinner } from 'components/loaders/full-page-loading-spinner.component';
import { useOnboardingFlow } from 'hooks/use-onboarding-flow.hook';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { GetStarted } from './get-started-screen.component';
import { AccountSetupForm } from './account-setup.form.component';

interface OnboardingWrapperProps {
  children: JSX.Element;
}

export const OnboardingWrapper = ({ children }: OnboardingWrapperProps) => {
  const navigate = useNavigate();
  const {
    isLoading,
    isSetupComplete,
    isOnboardingComplete,
    handleAccountSetupComplete,
    handleOnboardingComplete,
    setHasCompletedGetStarted,
    markAccountSetupCompletedWhenSkipping,
    showOnboardingField,
    userData,
  } = useOnboardingFlow();

  const handleAccountSetupSkip = async () => {
    // Call API to mark account setup as completed when skipping
    await markAccountSetupCompletedWhenSkipping();

    if (!showOnboardingField) {
      // When showOnboarding is false, go straight to home page
      navigate('/home');
    } else {
      // When showOnboarding is true, proceed to Get Started screen
      handleAccountSetupComplete();
    }
  };

  // Show loading only when we don't have user data yet (prevents brief flash of wrong screen)
  if (isLoading || !userData) {
    return <FullPageLoadingSpinner />;
  }

  if (!isSetupComplete) {
    return (
      <AccountSetupForm
        onComplete={handleAccountSetupComplete}
        onSkip={handleAccountSetupSkip}
      />
    );
  }

  if (!isOnboardingComplete) {
    return (
      <GetStarted
        handleOnboardingCompleted={handleOnboardingComplete}
        setHasCompletedGetStarted={setHasCompletedGetStarted}
      />
    );
  }

  return <BasePageProvider>{children}</BasePageProvider>;
};
